export class EnglishArabicDTO
{
    English:string;
    Arabic:string
}